import { render, staticRenderFns } from "./PageFormBtn.vue?vue&type=template&id=3fb6c594&"
import script from "./PageFormBtn.vue?vue&type=script&lang=ts&"
export * from "./PageFormBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports